import { Component } from '@angular/core';
import { RouteParams } from '@angular/router-deprecated';

import { SystemLockService, LoadingService } from '../services';

@Component({
    selector: 'systemlock',
    template: require('./systemlock.html'),
    providers: [SystemLockService],
    directives: [],
})
export class SystemLockComponent {
    institutionId: number;
    complete = false;

    constructor(
        protected svc: SystemLockService,
        params: RouteParams,
        protected loadingService: LoadingService
    ) {
        this.institutionId = parseInt(params.get('id'));
    }

    unlockSystem() {
        this.loadingService.startLoad();
        this.complete = false;

        this.svc.unlockSystem(this.institutionId)
            .subscribe((response) => {
                this.loadingService.stopLoad();
                this.complete = true;
            });
    }
}


/** WEBPACK FOOTER **
 ** ./app/system/SystemLockComponent.ts
 **/